import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { Spinner } from '@semsis/ui/Spinner';
import { ToastProvider } from '@semsis/ui/Toast';
import { ThemeProvider } from '@semsis/ui/theme';
import { ConsentProvider, CookieConsent } from '@referee/analytics';
import { ErrorBoundary } from '@referee/error-handling';
import { TestDataProvider } from './context/TestDataContext';
import { PracticeLayout } from './layouts/PracticeLayout';
import { TestModeLayout } from './layouts/TestModeLayout';

const RulesTest = lazy(() => import('./pages/RulesTest').then((m) => ({ default: m.RulesTest })));
const Stats = lazy(() => import('./pages/Stats').then((m) => ({ default: m.Stats })));
const About = lazy(() => import('./pages/About').then((m) => ({ default: m.About })));
const TestModeSetup = lazy(() => import('./pages/test-mode/TestModeSetup').then((m) => ({ default: m.TestModeSetup })));
const ExamView = lazy(() => import('./pages/test-mode/ExamView').then((m) => ({ default: m.ExamView })));
const TestModeResults = lazy(() => import('./pages/test-mode/TestModeResults').then((m) => ({ default: m.TestModeResults })));

export function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <ConsentProvider>
          <ToastProvider duration={3000}>
            <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '') || '/'}>
              <TestDataProvider>
                <Suspense fallback={<Spinner page />}>
                <Routes>
                  <Route element={<PracticeLayout />}>
                    <Route index element={<RulesTest />} />
                    <Route path="stats" element={<Stats />} />
                    <Route path="about" element={<About />} />
                    <Route path="test" element={<TestModeLayout />}>
                      <Route index element={<TestModeSetup />} />
                      <Route path="active" element={<ExamView />} />
                      <Route path="results" element={<TestModeResults />} />
                    </Route>
                  </Route>
                </Routes>
                </Suspense>
              </TestDataProvider>
            </BrowserRouter>
            <CookieConsent />
          </ToastProvider>
        </ConsentProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
